import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import NavigateBack from "../../components/NavigateBack";
import useSlider from "../../hooks/useSlider";
import Sidebar from "../sidebar/Sidebar";
import { useQuery } from "@tanstack/react-query";
import { getDataListbyId } from "../../services/services";
import { useParams } from "react-router-dom";
import useDetails from "../../hooks/useDetails";
import moment from "moment";
import ImageModal from "../../components/ImageModal";

const CompleteTaskdetail = () => {
  const isSlider = useSlider();
  const { t } = useTranslation();
  const details = useDetails();
  const { id } = useParams();
  const [show, setShow] = useState(false);

  const { data } = useQuery({
    queryKey: ["task-details", id],
    queryFn: async () => {
      const resp =
        !!id && (await getDataListbyId(id, details?.companyUID, true, true));
      let data = resp?.data?.data;
      return data ?? {};
    },
  });

   const howLongDidItTake = React.useMemo(() => {
  const c = data?.completeDetails;
  if (
    c?.startAt &&
    c?.completedAt &&
    c?.actualStartTime &&
    c?.actualEndTime
  ) {
    const start = moment(`${c.startAt} ${c.actualStartTime}`, "MM/DD/YYYY h:mm A");
    const end = moment(`${c.completedAt} ${c.actualEndTime}`, "MM/DD/YYYY h:mm A");

    const duration = moment.duration(end.diff(start));

    const days = duration.days();
    const hours = duration.hours();
    const minutes = duration.minutes();

    let result = [];

    if (days > 0) result.push(`${days} ${days === 1 ? "day" : "days"}`);
    if (hours > 0) result.push(`${hours} ${hours === 1 ? "hour" : "hours"}`);
    if (minutes > 0) result.push(`${minutes} ${minutes === 1 ? "minute" : "minutes"}`);

    if (result.length === 0) result.push("less than a minute");

    return result.join(" ");
  }
  return null;
}, [data]);

 
  return (
    <div className="mainbox">
      <Sidebar />
      <div className={isSlider ? "body-content close" : "body-content open"}>
        <Row>
          <Col xl={6}>
            <NavigateBack>{t("task.taskDetails")}</NavigateBack>
          </Col>
         
        </Row>
        <div className="tableOuter">
          <Row className="mb-3">
            <p className="colorDark font-18 mb-2"> {t("task.basicInfo")}</p>
            <Col className="infoColumn" xl={5}>
              <p className="mt-2">
                {t("task.taskListName")}:{" "}
                <span className="colorDark">{data?.name}</span>
              </p>
              <p className="mt-2">
                {t("task.employeeName")}:{" "}
                <span className="colorDark">
                  {data?.customerDetails?.userInfo?.name
                    ? data?.customerDetails?.userInfo?.name
                    : "N/A"}
                </span>
              </p>
              <p className="mt-2">
                {t("task.startTime")}:{" "}
                <span className="colorDark">
                  {data?.details?.startTime ? data?.details?.startTime : "N/A"}
                </span>
              </p>
              <p className="mt-2">
                {t("task.taskLocation")}:{" "}
                <span className="colorDark">
                  {data?.locations?.map((i) => i.name)?.join(", ")}
                </span>
              </p>
              <p className="mt-2">
                {t("task.pictureRequired")}:{" "}
                <span className="colorDark">
                  {data?.details?.pictureRequired
                    ? t("task.yes")
                    : t("task.no")}
                </span>
              </p>
            </Col>

            <Col className="CenterLine" xl={2}></Col>
            <Col className="infoColumn" xl={5}>
              <p className="mt-2">
                {t("task.taskName")}:{" "}
                <span className="colorDark">{data?.details?.taskName}</span>
              </p>
              <p className="mt-2">
                {t("task.createdOn")}:{" "}
                <span className="colorDark">
                  {moment(data?.createdAt).format("lll")}
                </span>
              </p>
              <p className="mt-2">
                {t("task.taskDate")}:{" "}
                <span className="colorDark">
                  {moment(data?.details?.taskDate).format("ll")}
                </span>
              </p>
              <p className="mt-2">
                {t("task.endTime")}:{" "}
                <span className="colorDark">
                  {data?.details?.endTime ? data?.details?.endTime : "N/A"}
                </span>
              </p>
              {/* <p>
                {t("task.comment")}: <span className="colorDark">20</span>
              </p> */}
            </Col>
            {data?.details?.image && (
              <Col md={12} className="d-flex align-items-start mt-3">
                <p> {t("task.image")}: </p>
                <span className="colorDark ms-2">
                  <img
                    src={data?.details?.image}
                    width={400}
                    role="button"
                    onClick={() => setShow(data?.details?.image)}
                  />
                </span>
              </Col>
            )}
          </Row>
          <Row className="mb-3">
            <p className="colorDark font-18 mb-2"> {t("task.ReportInfo")}</p>
            <Col className="infoColumn" xl={5}>
              <p className="mt-2">
                {t("task.whenWasItCompleted")}:{" "}
                <span className="colorDark">
                  {data?.completeDetails.completedAt}
                </span>
              </p>
              <p className="mt-2">
                {t("task.whoCompletedIt")}:{" "}
                <span className="colorDark">
                  {data?.completeDetails.completedBy
                    ? data?.completeDetails.completedBy
                    : "N/A"}
                </span>
              </p>
            </Col>

            <Col className="CenterLine" xl={2}></Col>
            <Col className="infoColumn" xl={5}>
              <p className="mt-2">
                {t("task.howLongDidItTake")}:{" "}
                <span className="colorDark">{howLongDidItTake ?? "N/A"}</span>
              </p>
              <p className="mt-2">
                {t("task.actualStartTime")}:{" "}
                <span className="colorDark"> {data?.completeDetails.actualStartTime
                    ? data?.completeDetails.actualStartTime
                    : "N/A"}</span>
              </p>
              <p className="mt-2">
                {t("task.actualStartTime")}:{" "}
                <span className="colorDark"> {data?.completeDetails.actualEndTime
                    ? data?.completeDetails.actualEndTime
                    : "N/A"}</span>
              </p>
             
            </Col>
          </Row>
        </div>
      </div>
      <ImageModal show={show} setShow={setShow} />
    </div>
  );
};

export default CompleteTaskdetail;
